import React from "react";
import { beautifyTcgPlayerApiCondition } from "../../utility";

const ConditionWarningText = (props) => {
  const { priceChartingProductInfo } = props;

  const handleIsShowTradingCardConditionWarningText = (
    priceChartingProductInfo
  ) => {
    try {
      let isShowWarning = false;
      const skus = priceChartingProductInfo?.productMetaData?.skus ?? [];
      const productMetaData = priceChartingProductInfo?.productMetaData ?? {};

      let propertiesCombinationObject = skus.find((obj) => {
        return (
          obj.language.name === productMetaData.language &&
          obj.printing.name === productMetaData.cardRarity
        );
      });
      if (propertiesCombinationObject) {
        let selectedConditionMarketPrice = 0;
        propertiesCombinationObject.condition.findIndex((cond, index) => {
          if (
            beautifyTcgPlayerApiCondition(cond.name) ===
            productMetaData.condition.value
          ) {
            selectedConditionMarketPrice =
              propertiesCombinationObject.prices[index].marketPrice;
          }
        });

        if (
          selectedConditionMarketPrice === 0 &&
          productMetaData.marketPrice !== 0
        ) {
          isShowWarning = true;
        }
      }

      return isShowWarning;
    } catch (e) {
      console.log(e);
      return false;
    }
  };

  return (
    handleIsShowTradingCardConditionWarningText(priceChartingProductInfo) && (
      <div className="w-100 d-flex justify-content-center trading-card-warning-text">
        <span>Price is only for Near-Mint condition</span>
      </div>
    )
  );
};

export default ConditionWarningText;
